import { render, staticRenderFns } from "./Mensalidade.vue?vue&type=template&id=ba33beae&scoped=true&"
import script from "./Mensalidade.vue?vue&type=script&lang=js&"
export * from "./Mensalidade.vue?vue&type=script&lang=js&"
import style0 from "./Mensalidade.vue?vue&type=style&index=0&id=ba33beae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba33beae",
  null
  
)

export default component.exports